export class PlanDetail {
    public idHeader: string;
    public title: string;
    public dtStart: Date;
    public dtEnd: Date;
    public targetCustomer1: string;
    public targetCustomer2: string;
    public targetCustomerNotes: string;
    public benefits: string;
    public planGoal: string;
    public mechanics: string;
    public mechanicsDescription: string;
    public modality: string;
    public targetVolume: number;
    public excludedProductsNotes: string;
    public allBrands: boolean;
    public costAllocationCheck: boolean;
    public allBrandsCost: boolean;
    public supportMaterials: string;
    public target: string;
    public commercialCampaignCode: string;
    public involvedProductsNotes: string;
    public currentVersion: [];

    constructor(
        idHeader?: string,
        title?: string,
        dtStart?: Date,
        dtEnd?: Date,
        targetCustomer1?: string,
        targetCustomer2?: string,
        targetCustomerNotes?: string,
        benefits?: string,
        planGoal?: string,
        mechanics?: string,
        mechanicsDescription?: string,
        modality?: string,
        targetVolume?: number,
        excludedProductsNotes?: string,
        allBrands?: boolean,
        costAllocationCheck?: boolean,
        supportMaterials?: string,
        target?: string,
        commercialCampaignCode?: string,
        involvedProductsNotes?: string,
        allBrandsCost?: boolean,
        currentVersion?: []
      ) {
        this.idHeader = idHeader;
        this.title = title;
        this.dtStart = dtStart;
        this.dtEnd = dtEnd;
        this.targetCustomer1 = targetCustomer1;
        this.targetCustomer2 = targetCustomer2;
        this.targetCustomerNotes = targetCustomerNotes;
        this.benefits = benefits;
        this.planGoal = planGoal;
        this.mechanics = mechanics;
        this.mechanicsDescription = mechanicsDescription;
        this.modality = modality;
        this.targetVolume = targetVolume;
        this.excludedProductsNotes = excludedProductsNotes;
        this.allBrands = allBrands;
        this.costAllocationCheck = costAllocationCheck;
        this.supportMaterials = supportMaterials;
        this.target = target;
        this.commercialCampaignCode = commercialCampaignCode;
        this.involvedProductsNotes = involvedProductsNotes;
        this.allBrandsCost = allBrandsCost;
        this.currentVersion = currentVersion;
      }
}